import React from 'react';
import PropTypes from 'prop-types';
import { find } from 'lodash';

class ProductOptions extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      // The free option is selected by default, or the first one if no free option
      selectedOption: find(props.options, ['price_cents', 0]) || props.options[0],
    }
  }

  onSelectedOptionChange = (event) => {
    const { options } = this.props;
    const optionId = +event.target.value;

    this.setState({
      selectedOption: find(options, ['id', optionId]),
    });
  }

  handleContinue = () => {
    this.props.onContinue(this.state.selectedOption);
  };

  render() {
    const { options, product } = this.props;
    const { selectedOption } = this.state;

    const total = ((selectedOption.price_cents || 0) + product.price_cents) / 100;

    return (
      <div>
        <ul className="text-center tunnel_steps">
          <li className="tunnel_steps_step active">
              <span>1</span>
          </li>
          <li className="tunnel_steps_step">
              <span>2</span>
          </li>
          <li className="tunnel_steps_step">
              <span>3</span>
          </li>
          <li className="tunnel_steps_step">
              <span>4</span>
          </li>
        </ul>

        <div className="clearfix">
          <h2 className="col-xs-12">Votre panier</h2>
        </div>
        <div className="col-sm-7 tunnel_main">
          <div className="sm-container tunnel_item">
            <div className="tunnel_item_img hidden-xs">
              <img src="/images/saut_tandem_maubeuge.jpg" alt="" />
            </div>
            <div className="tunnel_item_desc">
              <h4>Baptême de chute libre</h4>
              <span className="tunnel_item_desc__product">Saut en tandem</span>
            </div>
            <div className="tunnel_item_price">
              <span className="tunnel_item_price__label">Prix</span>
              <span className="tunnel_item_price__value">295 €</span>
            </div>
          </div>
          <div className="tunnel_options">
            <h4>Choisissez une option</h4>
            <p>
              Immortalisez avec un suivi vidéo.
            </p>
            <div>
              {options.map(option => (
                <div className="sm-container custom-radio" key={option.id}>
                  <input
                    type="radio"
                    name="option"
                    id={option.nom}
                    value={option.id}
                    checked={option.id === selectedOption.id}
                    onChange={this.onSelectedOptionChange}
                  />
                  <label htmlFor={option.nom}>
                    <span></span>{option.description} <i>+ {option.price_cents / 100} €</i>
                  </label>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="col-md-4 col-md-offset-1 col-sm-5 tunnel_side">
          <div className="sm-container">
            <h4 className="tunnel_side_items">Récapitulatif</h4>
            <ul className="tunnel_side_items">
              <li className="clearfix">
                <p className="col-xs-9 text-right">{product.description}</p>
                <p className="col-xs-3 text-right">{product.price_cents / 100} €</p>
              </li>
              <li className="clearfix">
                <p className="col-xs-9 text-right">
                  {selectedOption.description || 'Aucun suivi'}
                </p>
                <p className="col-xs-3 text-right">
                  {(selectedOption.price_cents || 0) / 100} €
                </p>
              </li>
            </ul>
            <div className="tunnel_side_final">
              <p className="tunnel_side_final_total">TOTAL <span className="bold">{total} €</span></p>
              <button className="btn btn-primary" onClick={this.handleContinue}>Continuer</button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

ProductOptions.propTypes = {
  product: PropTypes.object.isRequired,
  options: PropTypes.array.isRequired,
  onContinue: PropTypes.func,
};

export default ProductOptions;
